import { useState } from "react";
import { X, CheckCircle2, Star, Loader2, Trash2, Tag } from "lucide-react";
import { toast } from "sonner";
import { submitSalesSurvey } from "@/lib/api";

const PRIX = [["oui", "Oui"], ["partiellement", "Partiellement"], ["non", "Non"]];
const DUREE = [["moins_1_semaine", "Moins d'une semaine"], ["1_4_semaines", "1 a 4 semaines"], ["plus_1_mois", "Plus d'un mois"]];

export const SoldSurveyModal = ({ annonce, surveyDone, onClose, onDelete }) => {
  const [prix, setPrix] = useState("");
  const [duree, setDuree] = useState("");
  const [note, setNote] = useState(0);
  const [busy, setBusy] = useState(false);
  const [step, setStep] = useState(surveyDone ? "choice" : "survey");

  const submit = async () => {
    if (!prix || !duree || !note) { toast.error("Merci de repondre aux 3 questions"); return; }
    setBusy(true);
    try { await submitSalesSurvey(annonce.id, { prix_attentes: prix, duree_vente: duree, recommandation: note }); toast.success("Merci pour votre retour !"); setStep("choice"); }
    catch (e) { toast.error(e.response?.data?.detail || "Echec de l'envoi"); }
    finally { setBusy(false); }
  };

  const Choice = ({ options, value, onChange, testid }) => (
    <div className="flex flex-wrap gap-2">
      {options.map(([k, l]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`px-3 py-1.5 rounded-full text-sm font-semibold border transition ${value === k ? "bg-orange-500 text-white border-orange-500" : "border-neutral-300 hover:border-orange-400"}`}>{l}</button>
      ))}
    </div>
  );

  return (
    <div className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4" data-testid="sold-modal">
      <div className="bg-white rounded-3xl w-full max-w-md p-6 relative shadow-2xl">
        <button type="button" onClick={onClose} className="absolute top-3 right-3 p-1 rounded-full hover:bg-neutral-100" aria-label="Fermer" data-testid="sold-close"><X size={18} /></button>
        <div className="inline-flex items-center gap-2 text-emerald-700 font-black"><CheckCircle2 size={20} /> Felicitations, c'est vendu !</div>
        <p className="text-xs text-neutral-500 mt-1 truncate">{annonce.title}</p>

        {step === "survey" ? (
          <div className="mt-5 space-y-4" data-testid="sold-survey">
            <div><div className="text-sm font-bold mb-2">1. Le prix obtenu correspond-il a vos attentes ?</div><Choice options={PRIX} value={prix} onChange={setPrix} testid="survey-prix" /></div>
            <div><div className="text-sm font-bold mb-2">2. Combien de temps a dure votre vente ?</div><Choice options={DUREE} value={duree} onChange={setDuree} testid="survey-duree" /></div>
            <div>
              <div className="text-sm font-bold mb-2">3. Recommanderiez-vous Fodindin pour vendre ?</div>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} type="button" onClick={() => setNote(n)} aria-label={`${n} etoiles`} data-testid={`survey-note-${n}`} className="p-1">
                    <Star size={28} className={n <= note ? "fill-amber-400 text-amber-400" : "text-neutral-300"} />
                  </button>
                ))}
              </div>
            </div>
            <button type="button" onClick={submit} disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="survey-submit">
              {busy ? <Loader2 size={16} className="animate-spin" /> : null} Envoyer mes reponses
            </button>
            <button type="button" onClick={() => setStep("choice")} className="w-full text-xs text-neutral-500 underline" data-testid="survey-skip">Passer</button>
          </div>
        ) : (
          <div className="mt-5 space-y-3" data-testid="sold-choice">
            <p className="text-sm text-neutral-700">Que souhaitez-vous faire de l'annonce ?</p>
            <button type="button" onClick={onClose} className="w-full inline-flex items-center justify-center gap-2 rounded-2xl border-2 border-emerald-500 text-emerald-700 font-bold py-2.5 hover:bg-emerald-50" data-testid="sold-keep">
              <Tag size={16} /> Garder affichee avec le badge « Vendu »
            </button>
            <button type="button" onClick={onDelete} className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-red-600 text-white font-bold py-2.5 hover:bg-red-700" data-testid="sold-delete">
              <Trash2 size={16} /> Supprimer definitivement
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
